module.exports = __webpack_public_path__ + "static/best-meets-requirements-2f6c8987bde97a22a7fa7299437b7ad7.svg";